

import React, { useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import ProviderAPI from 'config/api/ProviderAPI'
import { onError } from 'config/lib/errorLib'
import Loader from 'components/general/Loader'
import WebsiteVerificationCard from 'components/provider/WebsiteVerificationCard'

function Verification() {
    const api = new ProviderAPI()
    const [company, setCompany] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getCompany()
    }, [])

    async function getCompany() {
        try {
            const company = await api.getCompany()
            setCompany(company)
            setLoading(false)
        } catch(e) {
            onError(e)
        }
    }

    return (
        <Container
            maxWidth={false}
            component={Box}
            marginTop='2rem'
        >
            {!loading ? (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12} md={7}>
                        <WebsiteVerificationCard
                            companyDetails={company}
                        />
                    </Grid>
                </Grid>
            ) : (
                <Grid container justifyContent='flex-start'>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='center' alignItems='center' style={{height: '20vh'}}>
                            <Loader />
                        </Box>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}

export default Verification